import { HttpResponse } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { AdminsService } from 'app/services/admins/admins.service';
import { TokenStorageServiceService } from 'app/services/admins/token-storage-service.service';
import { first } from 'rxjs/operators';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  form: any = {
    email: null,    // changed from 'username' to 'email' to match HTML
    password: null
  };
  isLoggedIn = false;
  isLoginFailed = false;
  errorMessage = '';
  roles: string[] = [];

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AdminsService,
    private tokenStorage: TokenStorageServiceService
  ) { }

  ngOnInit() {
    // Check actual authentication status using AdminsService (which checks token expiration)
    // instead of just token presence.
    if (this.authService.isLoggedIn()) {
      this.isLoggedIn = true;
      // Optionally load user roles if needed
      const user = this.tokenStorage.getUser();
      this.roles = user?.roles || [];
    } else {
      // If not logged in, ensure any stale token is cleared
      this.tokenStorage.signOut();
      this.isLoggedIn = false;
    }
  }

  onSubmit(): void {
    const { email, password } = this.form;
    this.authService.login(email, password).subscribe({
      next: data => {
        // Save token and user data using your token storage service
        this.tokenStorage.saveToken(data.accessToken);
        this.tokenStorage.saveUser(data);
        this.isLoginFailed = false;
        this.isLoggedIn = true;
        this.roles = this.tokenStorage.getUser().roles;
        this.router.navigate(['dashboard']);
      },
      error: err => {
        this.errorMessage = err.error?.message || 'Login failed';
        this.isLoginFailed = true;
      }
    });
    localStorage.setItem("email", email);
  }

  // Helper for template to show error when login fails
  get loginInvalid(): boolean {
    return this.isLoginFailed;
  }

  reloadPage(): void {
    window.location.reload();
  }
}